<template>
  <v-card v-if="cashoutMethod">
    <slot name="title">
      <v-toolbar color="grey lighten-4" light tile flat>
        <v-toolbar-title centered class="headline font-weight-bold">{{ title }}</v-toolbar-title>
        <div class="flex-grow-1"></div>

        <v-spacer></v-spacer>
        <v-btn color="primary" @click="isUpdating = true">
          <v-icon>mdi-pencil</v-icon>
          Edit
        </v-btn>
      </v-toolbar>
    </slot>

    <v-card-text>
      <v-row>
        <v-col cols="4">
          <key-value title="Id">
            <span class="small" v-text="cashoutMethod.id"></span>
          </key-value>
          <key-value title="Cashout Method Name" :value="cashoutMethod.name" />
          <key-value title="Type" :value="cashoutMethod.payment_type.name" />
          <key-value title="Provider" :value="cashoutMethod.payment_provider.name" />
        </v-col>
        <v-col cols="4">
          <key-value title="Min Amount (€)" :value="cashoutMethod.min_amount" type="date" />
          <key-value title="Max Amount (€)" :value="cashoutMethod.max_amount" type="date" />
        </v-col>
        <v-col cols="4">
          <key-value title="Apps">
            <ul>
              <li v-for="app in cashoutMethod.apps" :key="app">
                {{ app }}
              </li>
            </ul>
          </key-value>
        </v-col>
      </v-row>
    </v-card-text>
    <update-cashout-method-form
      method="put"
      :cashoutMethod.sync="cashoutMethod"
      :is-active.sync="isUpdating"
      @changed="cashoutMethodUpdated"
    ></update-cashout-method-form>
  </v-card>
</template>

<script>
import UpdateCashoutMethodForm from "./form";

export default {
  props: {
    dataCashoutMethod: Object,
    title: { default: "Crypto Cashout Method Details" },
    hideActions: { type: Boolean, default: false },
  },
  components: { UpdateCashoutMethodForm },
  data() {
    return {
      isUpdating: false,
      cashoutMethod: this.dataCashoutMethod,
    };
  },
  computed: {},
  methods: {
    cashoutMethodUpdated({ cashoutMethod }) {
      this.cashoutMethod = cashoutMethod;
      this.$emit("updated", cashoutMethod);
      this.isUpdating = false;
    },
  },
};
</script>
